import * as React from 'react';

import { ExpoWifiRttViewProps } from './ExpoWifiRtt.types';

export default function ExpoWifiRttView(props: ExpoWifiRttViewProps) {
  return (
    <div>
      <span>{props.name}</span>
    </div>
  );
}
